import { render } from "./Service.vue?vue&type=template&id=4ce081d3&scoped=true"
import script from "./Service.vue?vue&type=script&lang=js"
export * from "./Service.vue?vue&type=script&lang=js"

import "./Service.vue?vue&type=style&index=0&id=4ce081d3&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4ce081d3"

export default script